import classNames from "classnames"
import React, { ReactElement } from "react"

import viewManager from "~/shared/util/viewManager"

import "./PreviewBanner.less"

export default function PreviewBanner(): ReactElement | null {
  const previewId = viewManager.get("preview") as string | undefined
  const previewStatus = viewManager.get("previewStatus") as string | undefined
  const previewBranch = viewManager.get("previewBranch")
  const previewCommit = viewManager.get("previewCommit")
  const failed = previewStatus === "failed"

  if (!previewId) {
    return null
  }

  const label = failed
    ? "Preview failed to load"
    : previewBranch || previewCommit
      ? `Preview: ${[previewBranch, previewCommit].filter(Boolean).join(" @ ")}`
      : "Preview Mode"

  return (
    <div className={classNames("PreviewBanner", { "PreviewBanner--failed": failed })}>
      <span>{label}</span>
      <a href="/_preview/exit" className="PreviewBanner__link">
        Exit Preview
      </a>
    </div>
  )
}
